<template>
  <div class="test-buy-order-info">
    <el-divider content-position="center">测买目标信息</el-divider>
    <el-descriptions class="margin-top" :column="3" size="mini" border>
      <el-descriptions-item>
        <template slot="label">产品名称</template>{{ productinfo.productName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">产品链接</template>
        <a :href="productinfo.ur" target="_blank">{{ productinfo.url }}</a>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">套餐名称</template>{{ productinfo.skuMap }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">卖家名称</template>{{ productinfo.shopName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">掌柜号</template>{{ productinfo.sellerName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">渠道</template>{{ productinfo.channel }}
      </el-descriptions-item>
      <el-descriptions-item v-if="showaddress">
        <template slot="label">收货信息</template>{{ productinfo.receiveInfo }}
      </el-descriptions-item>
      <el-descriptions-item v-if="showaddress">
        <template slot="label">代付信息</template>支付宝代付
      </el-descriptions-item>
      <el-descriptions-item v-if="showaddress">
        <template slot="label">创建时间</template>
        {{ productinfo.appointTime != null ? $moment(productinfo.appointTime).format('YYYY-MM-DD H:mm:ss') : '' }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
export default {
  props: {
    productinfo: Object,
    showaddress: Boolean,
  },
}
</script>